import { FontIcon, IFontIconProps } from '@fluentui/react';

export interface IPFontIconProps extends IFontIconProps {}

export const IPFontIcon = (props: IPFontIconProps) => {
  return <FontIcon {...props} />;
};
